import { TradeToEarnCampaign } from "../api";
import { HubUserCredentials } from "../auth";
import { UneligibleTradeReason } from "../campaign";
import { TokenSymbol } from "../shared";
import { CreateOrderParams, CreateOrderRequest, Order } from "../untrustedApi";

export type WidgetEvents = "sendTxStatusUpdate" | "widgetClosed";

export type SendTxStatusUpdate = "submitted" | "txIdRetrieved" | "txIdNotRetrieved" | "failed";

export type WidgetTheme = {
  mode?: "dark" | "light";
  logoTheme?: "dark" | "light";
  fontFamily?: string;
  borderRadius?: number;
  primaryColor?: string;
  primaryTextColor?: string;
  secondaryTextColor?: string;
  inputBorderColor?: string;
  logoBorderColor?: string;
  borderColor?: string;
  errorColor?: string;
  warningColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  buttonTextColor?: string;
  deactivateButtonColor?: string;
};

export type TradeSubmittedParams = {
  orderParams: CreateOrderParams | CreateOrderRequest;
  order: Order;
  exchangeId?: string;
  exchangeUserId?: string;
  baseFiatAmount?: number;
  orderBookComputedValues?: OrderBookComputedValues;
};

export type TradeFailedParams = {
  orderParams: CreateOrderParams | CreateOrderRequest;
  exchangeId?: string;
  errorMessage?: string;
};

export type SpreadLevel = "good" | "warning" | "bad";

export type OrderBookComputedValues = {
  estimatedTradePrice?: number;
  depth2Up?: number;
  depth2Down?: number;
  spread?: number;
  spreadIndicator?: SpreadLevel;
};

export type WidgetConfig = {
  tokenSymbols?: TokenSymbol[];
  exchangeIds?: string[];
  recommendedToken?: TokenSymbol;
  /**
   * @remarks
   * Recommended token to sell/trade from (pre-fills tokenFrom in trade widget)
   */
  recommendedTokenFrom?: TokenSymbol;
  /**
   * @remarks
   * When true, only the recommendedToken (and tokens with common markets) will be available for selection.
   * When false, all tokens will be available even if a recommendedToken is set.
   * Defaults to true for backward compatibility.
   */
  recommendedTokenOnly?: boolean;
  /**
   * @remarks
   * Used to enable/disable exchanges for limit orders
   */
  limitOrderExchangeIds?: string[];
  /**
   * @remarks
   * Preferred exchange to prioritize when multiple exchanges are available
   */
  preferredExchange?: string;
  isHub?: boolean;
  keepPreviousTradeValues?: boolean;
  defiAddress?: string;
  onTradeSubmitted?: (params: TradeSubmittedParams) => void;
  onTradeFailed?: (params: TradeFailedParams) => void;
  campaignId?: string;
  hteCampaignId?: string;
  campaignMetadata?: TradeToEarnCampaign;
  onWalletDisconnect?: () => void;
  openCustomConnectModal?: () => void;
  auth: HubUserCredentials;
  requiresSocialAccounts?: boolean;
  hasSocialAccountsConnected?: boolean;
  onConnectSocialAccounts?: () => void;
  autoSelectTokens?: boolean;
};

export type WidgetProps = {
  config?: WidgetConfig;
  theme?: WidgetTheme;
  forceNavigation?: {
    path: string;
    params: {
      invalidAccessReason?: UneligibleTradeReason;
      defiAddresses?: string[];
      nextAccessDate?: Date;
    };
  };
};
